export enum EAssignmentMode {
  any = 1,
  all = 2
}

export enum JobStatus {
  succeeded = 'Succeeded',
  failed = 'Failed',
  running = 'Running',
  cancelled = 'Cancelled'
}

export interface OperationAssignmentResult {
  operation: string;
  applicationReferenceName: string;
  isAssignedToAny: boolean;
  isAssignedToAll: boolean;
}
